import { request } from '@/api';

export const getIndexEventsAPI = async (payload) => {
  const res = await request({
    method: 'get',
    url: '/events/view',
    params: payload,
  });
  return res.data;
};

export const getViewEventsAPI = async (payload) => {
  const { type, pageIndex } = payload;
  const params = {
    type,
    page: pageIndex,
    limit: 8,
  };

  const res = await request({
    method: 'get',
    url: '/events',
    params,
  });
  return res.data;
};

export const medicalTeamApplyAPI = async (payload) => {
  const res = await request({
    method: 'post',
    url: '/events/add/2',
    data: payload,
  });
  return res.data;
};

export const parentApplyAPI = async (payload) => {
  const res = await request({
    method: 'post',
    url: '/events/add/1',
    data: payload,
  });
  return res.data;
};
